import React, {useEffect, useState} from "react";
import {Apis} from "../util/data";
import axios from "axios";
import {useDropzone} from "react-dropzone";
import {errorToast, successToast} from "./layout/ToastStyles";
import {FaFilePdf} from "react-icons/fa6";
import Input from "./forms/FormEl";
import FormGroup from "./forms/FormGroup";
import {useForm} from "react-hook-form";

const UploadConsejeria =({setAction, setTitle,...props}) => {

  const [file, setFile] = useState(null);

  const {
    register,
    handleSubmit,
    formState:{errors}
  } = useForm();

  const upload = async (params) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('codigo', props.id ? props.codigo : params.codigo);
      const {data} = await axios.post(Apis.PROD + '/images/upload/pdf' + (props.id ? ('/' + props.id) : '' ), formData)
      if(data) successToast("Se ha subido correctamente")
    }
    catch (error){
      errorToast("Error al subir el pdf")
      console.log(error)
    }
  }

  useEffect(() => {
    setTitle("Subir pdf")
    setAction(()=>handleSubmit(upload))
  }, [file])

  const onDrop = (acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      setFile(acceptedFiles[0]);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({ accept: {'application/pdf': ['.pdf']},maxFiles: 1, onDrop });

  return (
    <div style={{display:'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center'}}>

      {!props.id && <FormGroup>
        <label>Codigo</label>
        <Input type='text' {...register("codigo", {required: "Campo obligatorio"})}/>
        {errors.codigo && <p style={{color: 'red'}}>{errors.codigo?.message}</p>}
      </FormGroup>}

      <div {...getRootProps()}
           style={{cursor: 'pointer', border: '1px dashed #ccc', padding: '20px', textAlign: 'center'}}>
        <input {...getInputProps()} />
        {file ? (
          <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
            <FaFilePdf size={24}/>
            <p>{file.name}</p>
          </div>
        ) : (
          <p>Arrastra un pdf o haz clic para seleccionar un archivo</p>
        )}
        <p>Tamaño maximo permitido: 10MB</p>
      </div>
    </div>
  );

}

export default UploadConsejeria;